import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./course-page.scss";
import Dropdown from "react-bootstrap/Dropdown";
import { PGDCourses, lecturers } from "../../TextData";
import { Courses } from "../../components/Courses/Courses";
import { Lecturers } from "../../components/Lecturers/Lectuerers";
import Image4 from "../../assets/images/cap.webp";

export const PGDPage = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const handleClick = (index) => setActiveIndex(index);
  const checkActive = (index, className) =>
    activeIndex === index ? className : "";

  const [widthM, setWidth] = useState(window.innerWidth);
  const [isMobile, setMobile] = useState(window.innerWidth <= 768);
  const [category, setCategory] = useState("*");
  const [filteredCourses, setFilteredCourses] = useState(PGDCourses);
  function setCat(cat) {
    setCategory(cat);
  }
  useEffect(() => {
    if (category === "*") {
      setFilteredCourses(PGDCourses);
    } else {
      setFilteredCourses(
        PGDCourses.filter((prd) => prd.category.indexOf(category) !== -1)
      );
    }
  }, [category]);
  const [state, setState] = useState({
    query: "",
    list: lecturers,
  });
  return (
    <>
      <div className="course-page2">
        <center>
          <h1>POSTGRADUATE COURSES</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Courses</h6>
        </div>
      </div>
      <div className="col-md-6 offset-md-3 flexy course-filter2">
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              All
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("*")}>
                View all courses
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              Programme
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("diploma1")}>
                POST GRADUATE DIPLOMA IN INDUSTRIAL PHYSICS
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("theory")}>
                M.Sc. IN THEORETICAL PHYSICS
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("solid")}>
                M.Sc. PHYSICS (SOLID STATE ELECTRONICS)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("applied")}>
                M.Sc. PHYSICS (APPLIED GEOPHYSICS)
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("material")}>
                M.Sc. PHYSICS (MATERIALS SCIENCE)
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("environment")}>
                M.Sc. PHYSICS (ENVIRONMENTAL PROTECTION AND RADIATION PHYSICS)
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("phd")}>
                PHD PROGRAMMES IN PHYSICS
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              Unit load
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("unitload1")}>
                1 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload2")}>
                2 unit load
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("unitload3")}>
                3 unit load
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("unitload4")}>
                4 unit load
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("unitload5")}>
                5 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload6")}>
                6 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload7")}>
                7 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload8")}>
                8 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload9")}>
                9 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload10")}>
                10 unit load
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              Choice
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("compulsory")}>
                Compulsory
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("elective")}>
                Electives
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="col-md-12  mt">
        <div className="offset-md-2 col-md-8 ">
          <section className="row row-cols-2 row-cols-lg-4  g-lg-4 col-md-12">
            {filteredCourses.map((data, index) => (
              <Courses data={data} />
            ))}
          </section>
        </div>
      </div>

      <div className="col-md-10 offset-md-1 mt transaction-page">
        <center>
          <h2>GRADUATE COURSE DESCRIPTION</h2>
        </center>
        <div className="tabs mt6">
          <button
            className={`tab ${checkActive(1, "active2")}`}
            onClick={() => handleClick(1)}
          >
            PGDP
          </button>
          <button
            className={`tab ${checkActive(2, "active2")}`}
            onClick={() => handleClick(2)}
          >
            M.Sc. IN THEORETICAL PHYSICS
          </button>
          <button
            className={`tab ${checkActive(3, "active2")}`}
            onClick={() => handleClick(3)}
          >
            M.Sc. PHYSICS (SOLID STATE ELECTRONICS)
          </button>{" "}
          <button
            className={`tab ${checkActive(4, "active2")}`}
            onClick={() => handleClick(4)}
          >
            M.Sc. PHYSICS (APPLIED GEOPHYSICS)
          </button>{" "}
          <button
            className={`tab ${checkActive(5, "active2")}`}
            onClick={() => handleClick(5)}
          >
            M.Sc. PHYSICS (MATERIALS SCIENCE)
          </button>{" "}
          <button
            className={`tab ${checkActive(6, "active2")}`}
            onClick={() => handleClick(6)}
          >
            M.Sc. PHYSICS (ENVIRONMENTAL PROTECTION AND RADIATION PHYSICS)
          </button>{" "}
          <button
            className={`tab ${checkActive(7, "active2")}`}
            onClick={() => handleClick(7)}
          >
            PHD PROGRAMMES
          </button>{" "}
        </div>
        <div className="panels">
          <div className={`panel ${checkActive(1, "active2")}`}>
            <center>
              <h3>
                COURSE DESCRIPTION FOR POST GRADUATE DIPLOMA PROGRAMME (PGDP)
              </h3>
            </center>
            <br />
            <h4>PHY 750.1: ICT and Research Methodology</h4>
            <p>
              This course should cover essential of spreadsheets, internet
              Technology, statistical packages, precision and Accuracy of
              Estimates, principles of scientific Research, concepts of
              Hypotheses formation and Testing, Organization of Research and
              Report Writing.
            </p>{" "}
            <h4>PHY 700.1 Vibrations and Waves</h4>
            <p>
              This course is an introduction to oscillations and waves
              phenomena. Topics covered will include vibrations and waves,
              electromagnetism waves, vibrating systems, types of waves, sound
              waves and wave optics.
            </p>{" "}
            <h4>PHY 701.1 Mathematical Physics.</h4>
            <p>
              This is an introductory mathematical methods course which is of
              particular interest to theoretical physics. Topics to be treated
              include introductory vector analysis; coordinate systems and their
              transformations. Motion in the various coordinate systems.
              Differential equations in two and three dimensions. Application of
              differential equations (partial and whole) in mechanics, electric
              circuits, atomic and nuclear physics, and boundary value problems.
            </p>{" "}
            <p>
              Complex variables and application; Fourier series and transforms;
              matrices and determinants; special functions like Bassel
              functions, Languere functions and polynomials; Hermite functions
              and polynomials; Lengendre equations and polynomials.
            </p>
            <h4>PHY 702.1 Thermodynamics and Statistical Physics</h4>
            <p>
              This course aims at presenting thermodynamics and statistical
              mechanics in a unified manner. Topics include quantum states,
              entropy, temperature, pressure, chemical potential, thermodynamics
              potential, grand sum and partition functions; distribution
              function, relationship of statistical variables of thermodynamic
              variables, applications, transport processes and fluctuation
              phenomenon. Maxwell-Boltzmann velocity distribution law.
            </p>{" "}
            <h4>PHY 703.1 Geometric and Physical Optics</h4>
            <p>
              Geometrical optics which discuss emission and absorption spectra
              and optical instruments.
            </p>{" "}
            <p>
              Wave equation in rectangular and polar coordinates, superposition
              of waves; production of coherent sources by division of wave
              fronts and of amplitude; applications. Michelson and Jamin
              Interferometers with wave front – Fabry-Perot etalon, Fresnel and
              Fraunhoffer diffraction patterns, polarization of lights
            </p>
            <h4>PHY 704.1 Atomic, Nuclear and Modern Physics</h4>
            <p>
              This is an introductory course on modern physics. Topics in atomic
              structure, photoelectric effect, black-body radiation, relativity,
              radioactivity, nuclear structure, mass spectrometers. Nuclear
              structure and properties; Nuclear models and nuclear reactions;
              vector model of the atom. Nuclear spectroscopy; X-ray spectra;
              alkali spectra. Zeeman and stark effect. Fundamental particles,
              strong and weak electromagnetic interactions. Resonance. The
              hydrogen atom; spin effect and relativistic effects. The diatomic
              molecule; the Frank-Condon principle. Identical particles and
              symmetry. Many electron atoms; coupling schemes and vector models.
              Zeeman effect and hyperfine structure. Resonance phenomena; EST,
              NMR and optical pumping, Messbauer Scattering; X-ray diffraction,
              microwave methods.
            </p>{" "}
            <h4>PHY 705.1 Advanced laboratory Practice</h4>
            <p>
              In the course, laboratory experiments are chosen from electronics,
              material science, atomic and nuclear, solid-state physics and the
              workshop course is intended to prepare the students for their
              research projects (PHY 449.0) by way of introducing them to the
              use of simple machine tools. Welding, soldering glass blowing,
              engineering drawing and design are also included. Problem solving
              and technical writing
            </p>{" "}
            <p>
              The aim of this course is to introduce students to an important
              aspect of any research finding – Reporting, presenting your
              results in an attractive way. Also, it is important that an
              undergraduate student should be able to define, analyse and
              possibly attempt to find solution to the problem. The course will
              cover: Introduction to problem formulation, identification,
              analysis and solutions. The main scientific approach to different
              types of problem. Examples could be drawn from the natural world,
              engineering and the prevailing, environmental problems. At the end
              of this section, the student should be able to formulate, analyse
              and suggest solutions to societal problems in a scientific manner.
            </p>
            <p>
              General introduction to technical writing (Hints on planning,
              content, present presentation and conclusions). Different types of
              writing and how they relate to the audience. Specific presentation
              of thesis with special reference to layout, abstract,
              introduction, conclusion and referencing other materials. Writing
              a dissertation, journal paper, technical reports. Presenting
              seminars, special projects and research reports. Project proposals
              and how to apply for research grants. Writing the first draft,
              editing and rewriting your own writing. Writing the submittal
              letters. Responding to corrections suggested by reviewers and
              correcting proofs. The importance of units and their abbreviations
              and standard symbols. Figures and how to caption your figures.
              Expression to avoid and apply in your writings.
            </p>
            <h4>PHY 751.2 Management and Entrepreneurship</h4>
            <p>
              The course will cover business environment general management,
              financial management entrepreneurship developments, feasibility
              studies marketing and managerial problem solving.
            </p>{" "}
            <h4>PHY 706.2 Electromagnetism (Electricity and Magnetism)</h4>
            <p>
              This course deals with the topics of electricity and magnetism
              seen in PHY 112.2 at a more advanced level. Topics include
              electrostatics, solutions of Laplace’s Equations, dielectric,
              static magnetic fields, magnetic materials, electromagnetic
              induction and Maxwell’s Equation. Topics include Polarization,
              dispersion, reflection and refraction of E.M. waves, guided waves,
              radiating systems, resonance cavities, transmission lines,
              diffraction and electrodynamics.
            </p>{" "}
            <h4>PHY 707.2 Solid State Physics</h4>
            <p>
              Crystal structure and X-ray crystallography and its experimental
              methods. Theory of solid classical free electron theory, quantum
              theory of electron gas and the band theory of solids. Electrical
              and thermal properties of solids. Bond theory of insulators and
              semi-conductors; dielectrics and fen electrics, magnetism in
              solids, magnetic resonance; super-conductivity; imperfections in
              solids; amorphous solids.
            </p>{" "}
            <h4>PHY 718.2 Seminar</h4>
            <p>
              Topics on current advancement in physics and other related field
              shall be considered.
            </p>{" "}
            <h4>PHY 719.2 Research Project</h4>
            <p>
              Topics for research projects will be assigned near the end of the
              student’s 1st Semester. The projects may be on topics of current
              interest in all areas of physics and Applied Physics. ELECTIVES
            </p>{" "}
            <h4>PHY 708.2 Quantum Mechanics</h4>
            <p>
              Inadequacies of classical mechanics, differences between classical
              I and quantum mechanics; wave-particle properties, Heisenberg’s
              uncertainty principles, wave and state functions; principles of
              Quantum mechanics; Schrodinger’s wave mechanics formulation,
              postulates of quantum mechanics, matrix representation of Quantum
              mechanics, time-independent Schrodinger’s wave equation; wave
              mechanics for some simple system; wave mechanics of atoms.
              Degenerate and non-degenerate steady state permutation theory,
              identical particles, the matrix formulation of quantum mechanics.
              Time-dependent perturbation theory, the relativistic wave
              equation, origin of the electron spin.
            </p>{" "}
            <h4>PHY 709.2 Theoretical and Fluid Mechanics</h4>
            <p>
              Newtonian Mechanics. Motion of a particle in one-, two- and
              three-dimension, system of particles and collision theory,
              Newtonian gravitation, conservative forces and potentials,
              oscillations, central force problems, accelerated frames of
              reference, rigid body dynamics, generated motions; mechanics of
              continuum media. Fluid statics and dynamics.
            </p>{" "}
            <h4>PHY 710.2 Materials Science</h4>
            <p>
              Introduction to material based on properties of solids,
              microstructure forming and shaping. This should illustrate the
              importance of the range of currently available engineering
              materials and to show that technology development depends on (1)
              introducing new materials and new processes (2) awareness of
              limitations of existing materials and processes. Topics include:
            </p>
            <ul>
              <li>Atomic and atomic coordination</li>
              <li>atomic order in solids and molecular disorder</li>
              <li>single-phase materials and molecular phases</li>
              <li>ceramic polymer materials</li>
              <li>conducting materials</li>
              <li>magnetic and electrical materials</li>
              <li>phase diagrams</li>
              <li>processing and development of microstructure/composites.</li>
              <li>Performance materials and devices</li>
              <li>Designing with different materials</li>
              <li>performance criteria and standards</li>
              <li>Selected case studies of material selection.</li>
            </ul>{" "}
            <h4>PHY 711.2 Introduction to Geophysics</h4>
            <p>
              This course introduces the students to the art of Geophysical
              exploration using seismic methods. At the end of the course, the
              student should have mastered theoretical aspects of seismic
              methods, including characteristics of elastic waves and their
              propagation. Reflection, Refraction, Generation of seismic waves,
              Instruments, Digital recording and Field Instrumentation. Data
              acquisition principles and Data processing Basics. Basic
              interpretation
            </p>{" "}
            <h4>PHY 712.2 Geophysical Prospecting Methods</h4>
            <p>
              Gravity and magnetic methods, Electrical methods, seismic method,
              Electromagnetic method and Radiometrics shall be treated
            </p>{" "}
            <h4>PHY 713.2 Introduction to Environmental Technology</h4>
            <p>
              Environmental technology and Environmental Science. Measurement
              and Evaluation of environmental pollution in air, water and land:
              legal and technical requirements in the preparation,
              interpretation of environmental impacts. The procedure and
              interdisciplinary nature of environmental analysis.
            </p>
            <ul>
              <li>
                Impact Evaluation, Qualification of Impacts, Fields, Mitigation,
                Understanding the sources and projects that cause Environmental
                degradation Remediation of gaseous pollutants.
              </li>
              <li>
                Removal of gaseous oxides of nitrogen, Carbon and sulphur.
                Removal of particulates from moving and stationary sources.
                Removal of fluorides complex oxidants and mercury vapour. The
                principles of reactions and physical measurements applied for
                variety of analytical equipment employed in air quality studies.
              </li>
              <li>
                Practical examples and case studies will be used. These may
                include evaluation and analysis of
              </li>
              <li>
                Social and industrial Noise, Vibration hazards, toxic and
                radioactive materials
              </li>
            </ul>{" "}
            <p>
              Statistical analysis and modelling of environmental systems.
              In-situ and online measurement of environmental pollution. Types
              of environmental studies, EIA. EAR. Environmental Monitoring
            </p>
            <h4>PHY 714.2 Non-Ionizing Radiation</h4>
            <p>
              Ultraviolet radiation, micro wave radiation, electromagnetic
              radiation x-rays, Bleared Gamma radiation. Radiometric Units
              Lasers. Laser operations. Lasing actions, TEM modes, biological
              effects: eye damage, skin damage Protection guides and standards,
              maximum permissible Exposure (MPE). Safety Measurements, power and
              energy. Beam divergence Radiofrequency (RF) and Microwave:
            </p>
            <ul>
              <li>Communications, antennas and antenna gain</li>
              <li>G. penetration depth GSM hand-sets and base stations</li>
              <li>Biological Effects</li>
              <li>Thermal and Non- Thermal Effects</li>
              <li>temperature-humidity index microwave measurement</li>
              <li>Survey meters</li>
              <li>
                Protection Guides and standard Maximum permissible exposure
                (MPE) Safety
              </li>
            </ul>
            <h4>PHY 715.2 Electronic Instrumentation</h4>
            <p>
              Brief review; passive devices, active devices, two-port network
              feedback circuits, transistor oscillator. Circuit models of
              transistors, FET Applications. Differential amplifier, small
              signal analysis, trigger circuits. Operational amplifier band
              width, different Integrated circuit; fabrication and testing and
              thin film and thick film circuits, passive and active elements.
              Logic devices and combinational circuits; DL, DTL, TTL, CMOS, etc.
              digital integrated circuits, synthesis of combinational Logic
              Circuits, FLOP and DE multiplexers. ROM, Sequential Logic
              Circuits, FLOP Circuits RAM. Introduction to microprocessors and
              Logic applications. Network theory. Discrete electronic systems;
              Analog and Digital meters, transducers, rate meters (frequency
              domain CRO).
            </p>
            <h4>PHY 716.2 Physics of Semi-Conductor Devices</h4>
            <p>
              Semi-conducting materials. Materials used in solid-state devices
              and in basic research preparation and measurement of
              semi-conducting materials, silicon and germanium, other elemental
              semiconductors. Ternary and Quaternary compounds, etc. P-N
              junction Devices, moderate – field P – N junction, tunnel diodes,
              I –M-PATT diode, etc. interface and thin film devices, Schottky
              effect, Metal-semi-conductor, RMPATT diode, metal Insulator
              Semi-conductor (MIS); or metal-oxide semi-conductor (MOS), surface
              states charges and space charges. Optoelectronic devices,
              electroluminescent devices, solar cell, photo detectors, junction
              lasers, laser materials etc.
            </p>
            <h4>PHY 717.2 Thin Film Technology and Solar Materials</h4>
            <p>
              Preparation, structure, evaluation and properties of thin films;
              metallic, semiconductor and dialectic film techniques. Nucleation
              and growth consideration, epitaxy and metastable configuration.
              Solar materials characteristics and their applications.
            </p>
            <p>
              Visible and infrared light sources, black body radiations,
              radiation by atoms, stimulated emission of radiation, coherent
              light sources and electro-optics effects/application.
            </p>
            <h4>M.Sc./PhD PROGRAMMES</h4>
            <p>
              The programme is geared towards (a) the production of high calibre
              specialists in the various options for services in higher
              institutions and the industry (b) the introduction of high level
              of research experiences and (c) the development of originality,
              interdisciplinary and cooperative research, analytical and
              critical mind.
            </p>
            <h4>1. REGULATIONS</h4>
            <p>
              The programmes for M.Sc. degrees shall consist of a minimum of 30
              credit units and a maximum of 48 credit units. The other 4 credit
              units will come from approved compulsory/elective courses for
              graduate programmes. However compulsory courses may not be
              repeated at higher levels if already passed at post graduate
              diploma or Masters Levels
            </p>
            <h4>2. DURATION OF PROGRAMME</h4>
            <p>
              The M.Sc. candidates will be required to spend a minimum of 12
              calendar months (1 year) and a maximum of 24 calendar months (2
              years) for Full-Time. Part-Time candidates will be required to
              spend a minimum of 24 calendar months (2 years) and a maximum of
              36 calendar months (3 years).
            </p>
            <h4>3. ADMISSION REQUIREMENTS FOR M.SC./PHD PROGRAMMES</h4>
            <p>
              Admission into the Post-Graduate programme of the Department
              requires a Bachelor’s degree in Physics or related programmes from
              the University of Port Harcourt or any other recognized University
              approved by the senate of the University of Port Harcourt. Note
              that five credits O/level in Mathematics, English Language,
              Physics, Chemistry and Biology is required. A minimum of
              second-class lower degree with a CGPA of not less than 3.0 or PGDP
              holders with upper credit (CGPA 3.5 points on a Scale of 5) level
              pass is required for the M.Sc. admission. For those intending to
              pursue a PhD programme of the department, candidate must have
              M.Sc. Degree in relevant field with a minimum CGPA of 3.5. All
              prospective PhD candidates are mandatorily required to attend a
              pre-admission oral interview, at which he/she is expected to
              present and defend a well written proposal and score a minimum of
              60 %. Prospective PhD candidates are encouraged to visit the
              department and interact with prospective supervisor(s) with a view
              to establishing area(s) of interest and vacancy.
            </p>
          </div>
          <div className={`panel ${checkActive(2, "active2")}`}>
            {" "}
            <center>
              <h3>COURSE DESCRIPTION FOR M.Sc. IN THEORETICAL PHYSICS</h3>
            </center>
            <br />
            <h4>PHY 801.1 Mathematical Physics</h4>
            <p>
              Difference; ordinary and partial differential equations; integral
              equations, green functions, the Approximation Methods (WKB,
              porturbatia-applications to solution in quantum mechanics),
              Cauchy-Riemann problems, Fundamental solutions of Laplace; Wave
              and Heat equations; Transforms and Asymptotic methods; the
              calculus of variation and Non-linear problems in Physics (Special
              Functions).
            </p>{" "}
            <p>
              Variational principles. Lagrange’s and Hamilton’s formulations.
              Poisson brackets. Canonical and non-canonical transformations.
              Hamilton-Jacobi theory. Rotation of rigid bodies. Theory of small
              oscillations. Symmetry and conservation laws. Introduction to
              relativistic dynamics.
            </p>
            <h4>PHY 802.1Advanced quantum Mechanics &Applied Group Theory</h4>
            <p>
              Classical variables and quantum mechanical operators,
              commutations, eigen-functions, normalization procedures,
              expectation value. Stationary State, Solutions of simple problems.
              Orbital angular momentum operators. Slater’s treatment of complex
              atoms: Hartree-Fock method, Thomas-Fermi model. Matrix Mechanics,
              Mathematical framework. Vector space, Dirac notation; operator
              algebra and matrices. Description of physical phenomena.
              Perturbation theory and approximation methods.
            </p>
            <h4>Applied Group Theory</h4>
            <p>
              Definition and theorem, theory of group representations. Symmetry
              in the solid state; point groups and space groups. The
              3-dimensional rotation group, continuous group, single and double
              valued representations; physical applications; crystal field
              splitting, symmetry adapted functions; normal modes of vibrations,
              symmetry properties of wave functions in crystals; factorization
              of secular determinants symmetry and the magnetic state.
            </p>
            <h4>PHY 803.1 Electromagnetic Theory</h4>
            <p>
              Electrostatic potentials. Poisson and Laplace’s equations. Method
              of images, green’s theorem, multipole expansions. Electromagnetic
              field stone’s theorem, Gauss’s theorem. Scalar and vector
              potentials. Maxwell’s equations. Propagation of electromagnetic
              waves in different media – conductive and non-conductive media,
              ionized and non-ionized media. Phase velocity, group velocity and
              pulse propagation, attenuation, refraction, energy propagation and
              transfer, polarization and dispersion. Green’s function method,
              diffraction theory, simple radiating systems, Lagrangian
              derivation of Maxwell’s equations and the covariant structure of
              electromagnetism.
            </p>
            <h4>PHY 804.1 Applied Electronics Workshop</h4>
            <p>
              Workshop safety precautions. Basic hand tools and bench work
              practice. Plain and cylindrical generation of smooth surface using
              power operated machines. Selection and properties of materials
              used for construction metallic and non-metallic. Metal joining
              devices and adhesives and common use. Soldering techniques and
              wrap joints. Multi-meters and oscilloscopes. Auto-ranging in
              measuring instruments. A survey of the use of electronic circuit
              devices e.g., diodes, transistors including FET, integrated
              circuits, photocells. Selection, use and care of test instruments.
              Survey of pick-ups and transducer devices. Basic circuit synthesis
              and analysis. Pulse circuits. Instrumentation and measuring
              techniques: impedance matching. Probes active and input and output
              impedance using the scope.
            </p>
            <h4>PHY 805.1 Fluid Dynamics and Transport Theory</h4>
            <p>
              Differentiation following the motion of fluid particles. Equations
              of motion and continuity for incompressible inviscid fluids.
              Velocity potentials and stoke stream function. Bernoulli’s
              equation with application to flow along curved paths. Kinetic
              energy, sources, sinks, doubles in 2 and 3 divisions. Limiting
              stream lines. Physics of continue mechanics, and equations of
              transport; Applications to flow in various media.
            </p>
            <h4>PHY 806.1 Thermodynamics and Statistical mechanics</h4>
            <p>
              Basic postulates of thermodynamics of simple, homogeneous systems.
              Thermodynamic potentials and stability of thermodynamic systems.
              Gibb’s theory of thermodynamics with interaction effects.
              Partition functions of different ensembles. Fundamental
              equilibrium theory; Lioville’s theorem and the Ergodic hypothesis.
              Distribution functions, entropy and connections with
              thermodynamics. Microcanonical, canonical and grand canonical
              ensembles. The density matrix. Maxwell-Boltzmann, Bose-Einstein
              and Fermi – Dirac distribution. Functions and statistics. Phase
              equilibria, first and second order transitions. Applications to
              classical and quantum systems. Boltzmann equation. Brownian motion
              and applications.
            </p>
            <h4>PHY 850.1 ICT and Research Methodology</h4>
            <p>
              This course should cover essential of spreadsheets, internet
              Technology, statistical packages, precision and Accuracy of
              Estimates, principles of scientific Research, concepts of
              Hypotheses formation and Testing, Organization of Research and
              Report Writing.
            </p>
            <h4>PHY 851.2 Management and Entrepreneurship</h4>
            <p>
              The course will cover business environment general management,
              financial management entrepreneurship developments, feasibility
              studies marketing and managerial problem solving.
            </p>
            <h4>PHY 807.2 Nuclear Physics and Instrumentation</h4>
            <p>
              Nuclear properties. Nuclear force, single particle potentials and
              the two-body nuclear interactions. The deuteron. Scattering
              process: n – p, n-n, p-p scattering. Nuclear structure and nuclear
              models including vibrational modes and rotational states of the
              nucleus. Fission and fusion reactions, aspects of nuclear
              reactions and energy generation. Relativistic description of
              nuclear particle states. Nuclear Instrumentations
            </p>
            <h4>PHY 808.2 Basic Plasma Physics and Space science</h4>
            <p>
              Concept of plasma Physics; Equation of Gas dynamics (the
              conservation laws); Basic plasma parameters; Neutrality condition
              plasma frequency and the Debye length; Plasma Transport and
              Dynamics (the Maxwell equations); MHD Equations; instabilities in
              Plasmas; Examples of Natural Plasmas; the earth’s ionspere; the
              ionosphere of other planets; magnetosphere; reactions in the sun;
              solar wind and solar flux.
            </p>
            <h4>Space Science and Applications</h4>
            <p>
              Earth’s atmosphere; Ionospheric layers and processes; Ionospheric
              Dynamics/changes; Ionospheric current; Basic Astrophysics, solar
              environment; solar wind, solar terrestrial interactions
            </p>
            <h4>PHY 809.2 Seminar in Advances in Theoretical Physics</h4>
            <p>
              Students will be required to give seminars on topics of current
              research interest in solid state Physics including those of their
              project(s) and/or other branches of Physics.
            </p>
            <h4>PHY 819.2 Research Project in Theoretical Physics</h4>
            <p>
              This will be in the form of a project report of an investigation
              carried out on a research topic (theoretical or experimental) of
              interest in Physics
            </p>
            <h3>
              Electives (Students are required to choose any two courses from
              these electives)
            </h3>
            <h4>PHY 810.2 Numerical Methods and computation of Physics</h4>
            <p>
              Modelling the art of transforming real life situation into
              mathematical statements. Applications to problems in Physics and
              dynamical system, programming languages; and use of packages;
              Solutions of algebraic Equations; Finite in difference method;
              interpolation techniques; Numerical differentiation and
              integrations; Numerical solutions of differential equations; the
              Finite Element and Rungae-kutta Methods; Curve fitting.
              Applications to the problems in fluid dynamics; heat and mass
              transfer and transport systems.
            </p>
            <h4>PHY 811.2 Quantum Field Theories</h4>
            <p>
              Interactions of a point particle. Symmetric and conservation laws,
              fundamental invariants, energy-momentum tensor. Neother’s theorem.
              Green’s functions. Radiations. Relativistic Wave equations; the
              klein-Gordon equation. Dirac equation and the Weyl equation. Dirac
              propagator. Quantization of fields: scalar field, quantized
              radiation field, massive vector fields. Interaction with external
              fields: emission probabilities.
            </p>
            <p>
              Compton effect, Pair creation and annihilation, Bremmstranhlung
              etc. perturbation theory. Feynmann rules. Feynmann diagrams.
              Radiative corrections and renormalization: vacuum corrections,
              electron propagator, vertx functions, the Lamb shift, the
              anomalous magnetic moment. Functional methods. Introduction to
              Gauge Field theories.
            </p>
            <h4>PHY 851.2 Management and Entrepreneurship</h4>
            <p>
              The course will cover business environment general management,
              financial management entrepreneurship developments, feasibility
              studies marketing and managerial problem solving.
            </p>{" "}
            <h4>PHY 861.1 Atmospheric physics and meteorology</h4>
            <p>
              The Solar-Earth atmospheric processes. The parameters for climate
              and meteorology. Hydrological cycle, precipitation, evaporation,
              atmospheric circulation, Energy budget, Ozone layer, Green House
              effects, Global warming. Structure of the Atmosphere and its
              constituents. Atmospheric-Environmental Model, Land and sea
              Breeze. Wind flow and its dynamics, Radiation, Temperature,
              Humidity, Atmospheric particulates emission and control and
              General circulation models.
            </p>{" "}
            <p>
              Surface and groundwater dynamics. Types of aquifers. Introduction
              to the theory of diffusion of pollutants and methods for
              estimation of dispersion in the atmosphere. Nature of turbulent
              motion in various environment. Dispersion of pollutants in water
              bodies. Air Pollution chemistry. Effects of atmospheric pollution
              on various forms of life including direct and secondary effects.
              Corrosion, contamination of inert matter by pollution, Ultraviolet
              Radiation, microwave Radiation, Laser Radiation, X-rays. Beta and
              Gamma radiation. Introduction of fuels, combustion. Pollutants,
              carbon dioxide, carbon monoxide. Nitrogen oxides, Sulphur
              dioxides. Monitoring equipment, vehicles, homogenate compound,
              photochemical pollution and acid rain.
            </p>
          </div>
          <div className={`panel ${checkActive(3, "active2")}`}>
            <center>
              <h3>
                COURSE DESCRIPTION M.Sc. PHYSICS (SOLID STATE ELECTRONICS)
              </h3>
            </center>
            <br />
            <h4>PHY 801.1 Mathematical Physics</h4>
            <p>
              Vector differentiation operations. Complex variables and
              applications, Integral transforms and applications, special
              functions of mathematical physics and partial differential
              equations and applications, integral equations, calculus of
              variations. Lagrange’s and Hamiltonian equations. Rotation of
              rigid bodies (review). Tensor algebra, Inertia and stress tensors.
              Theory of small vibration, relativistic dynamics.
            </p>
            <p>
              Review of basic principles of electromagnetic theory, Maxwell’s
              equations, vector and scalar potentials, conservation laws,
              methods in electrostatics and magneto statics, propagation of E.M.
              waves in various media (conducive, dispersive, etc.). Dispersion
              theory, scattering and diffraction of E.M. waves. Motion of
              charged particles in uniform and non-uniform electric and magnetic
              field, collision and energy loss, Radiation by moving charge
            </p>
            <h4>PHY 802.1 Advanced quantum mechanics& Applied Group Theory</h4>
            <p>
              Classical variables and quantum mechanical operators,
              commutations, eigen-functions, normalization procedures,
              expectation value. Stationary State, Solutions of simple problems.
              Orbital angular momentum operators. Slater’s treatment of complex
              atoms: Hartree-Fock method, Thomas-Fermi model. Matrix Mechanics,
              Mathematical framework. Vector space, Dirac notation; operator
              algebra and matrices. Description of physical phenomena.
              Perturbation theory and approximation methods.
            </p>
            <h4>Applied Group Theory</h4>
            <p>
              Definition and theorem, theory of group representations. Symmetry
              in the solid state; point groups and space groups. The
              3-dimensional rotation group, continuous group, single and double
              valued representations; physical applications; crystal field
              splitting, symmetry adapted functions; normal modes of vibrations,
              symmetry properties of wave functions in crystals; factorization
              of secular determinants symmetry and the magnetic state.
            </p>
            <h4>PHY 812.1 Semi-conductor Physics</h4>
            <p>
              The elementary properties of semi-conductors; control of carrier
              density, impurities and imperfections in crystal and carrier
              concentration in thermal equilibrium electron transport phenomena;
              collisions with crystalline imperfections, constant relaxation
              time. Relaxation time as a function of E, etc. Thermal effects in
              semi-conductors, thermal conductivity, thermo-electric power,
              thermo-magnetic effects, etc. diffusion and conduction in
              extrinsic materials, drift mobility of electrons and holes, etc.
              scattering of electrons and holes, change holes; recombination
              mechanisms; radioactive recombination, recombination through
              traps, etc, optical and high frequency effects in semi-conductors,
              free carrier absorption, plasma resonance, emission of radiation
              from semi-conductors.
            </p>
            <h4>PHY 813.1 Electronic Instrumentation.</h4>
            <p>
              Brief review; passive devices, active devices, two-port network
              feedback circuits, transistor oscillator. Circuit models of
              transistors, FET Applications. Differential amplifier, small
              signal analysis, trigger circuits. Operational amplifier band
              width, different Integrated circuit; fabrication and testing and
              thin film and thick film circuits, passive and active elements.
              Logic devices and combinational circuits; DL, DTL, TTL, CMOS, etc.
              digital integrated circuits, synthesis of combinational Logic
              Circuits, FLOP and DE multiplexers. ROM, Sequential Logic
              Circuits, FLOP Circuits RAM. Introduction to microprocessors and
              Logic applications. Network theory. Discrete electronic systems;
              Analog and Digital meters, transducers, rate meters (frequency
              domain CRO).
            </p>
            <h4>PHY 814.1 Applied Electronics and Workshop Practice</h4>
            <p>
              Workshop safety precautions. Basic hand tools and bench work
              practice. Plain and cylindrical generation of smooth surface using
              power operated machines. Selection and properties of materials
              used for construction metallic and non-metallic. Metal joining
              devices and adhesives and common use. Soldering techniques and
              wrap joints. Multi-meters and oscilloscopes. Auto-ranging in
              measuring instruments. A survey of the use of electronics circuit
              devices e.g., diodes, transistors including FET, integrated
              circuits, photocells. Selection, use and care of test instruments.
              Survey of pick-ups and transducer devices. Basic circuit synthesis
              and analysis. Pulse circuits. Instrumentation and measuring
              techniques: impedance matching. Probes active and input and output
              impedance using the scope.
            </p>
            <h4>PHY 850.1: ICT and Research Methodology</h4>
            <p>
              This course should cover essential of spreadsheets, internet
              Technology, statistical packages, precision and Accuracy of
              Estimates, principles of scientific Research, concepts of
              Hypotheses formation and Testing, Organization of Research and
              Report Writing.
            </p>
            <h4>PHY 851.1 Management and Entrepreneurship</h4>
            <p>
              The course will cover business environment general management,
              financial management entrepreneurship developments, feasibility
              studies marketing and managerial problem solving.
            </p>
            <h4>PHY 815.2 Advanced Solid State Physics</h4>
            <p>
              Quick review of Crystal structures and crystallographic symmetry.
              Theory of solids, Brillouin zones, concept of electrons and holes.
              Thermal properties: Phonons and Phenon spectra Optical properties,
              optical spectra and excitors. Magnetic properties spin waves and
              magnetic spectra, Para magnetic resonance. The many body problems
              in solid.
            </p>
            <h4>PHY 816.2 Physics of Semi-Conductor</h4>
            <p>
              Semi-conducting materials. Materials used in solid-state devices
              and in basic research preparation and measurement of
              semi-conducting materials, silicon and germanium, other elemental
              semiconductors. Ternary and Quaternary compounds, etc. P-N
              junction Devices, moderate – field P – N junction, tunnel diodes,
              I –M-PATT diode, etc. interface and thin film devices, Schottky
              effect, Metal-semi-conductor, RMPATT diode, metal Insulator
              Semi-conductor (MIS); or metal-oxide semi-conductor (MOS), surface
              states charges and space charges. Optoelectronic devices,
              electroluminescent devices, solar cell, photo detectors, junction
              lasers, laser materials etc.
            </p>
            <h4>
              PHY 817.2Basic Model Concepts and Manifest Properties of Solids
            </h4>
            <p>
              Properties of Energy bands in solids. Wave function for an
              electron in a periodic potential, energy bands in a perturbed
              nearly free electron system. Energy band calculations, density of
              states in energy bands. Introduction to energy bands in solids.
              Optical processes in solids. Absorption and reflection phenomena.
              Carrier recombination and luminescence, direct and indirect
              transitions. Excitations, colour and lasers. Photoelectric
              phenomena
            </p>
            <h4>PHY 818.2 Seminars in Advances in Solid State Electronics.</h4>
            <p>
              Students will be required to give seminars on topics of current
              research interest in solid state electronics including those of
              their project(s) and/or other branches of Physics.
            </p>
            <h4>PHY 819.2 Research Project</h4>
            <p>
              This will be in the form of a project report of an investigation
              carried out on a research topic (theoretical or experimental) of
              interest in Solid State Electronics
            </p>
            <h4>PHY 851.2 Management and Entrepreneurship</h4>
            <p>
              The course will cover business environment general management,
              financial management entrepreneurship developments, feasibility
              studies marketing and managerial problem solving.
            </p>
          </div>
          <div className={`panel ${checkActive(4, "active2")}`}>
            <center>
              <h3>M.Sc. PHYSICS (APPLIED GEOPHYSICS)</h3>
            </center>
            <br />
            <h4>PHY 820.1 Physics of the Earth’s Interior</h4>
            <p>
              Structure of the earth’s interior, continental and oceanic crust
              and the mantle. Isocracy; structure of the core, terrestrial heat
              flow, ocean ridges, mountain ranges, rift valleys and ocean
              trenches, continental drift and seafloor spreading. Use of
              geophysics techniques in the study of the earth’s interior. The
              earth’s magnetic field, its description and origin, magnetization
              of rocks, reversal of the earth’s magnetic field, radioactive age
              dating isotope geology; statistical analysis of paleomagnetic
              data, polar wandering and continental drift. Response of
              geological material to applied stress. Brittle failure, plastic
              deformation and creep in rocks. Applications of these principles
              to large scale geologic structures (principally lithospheric
              plates).Mechanics of lithospheric plates and mechanism of plate
              tectonics.
            </p>{" "}
            <h4>PHY 821.1 Potential Field Theory.</h4>
            <p>
              The concept of potential will be introduced in this course as a
              preparation for the more specialized discussion of potentials
              field methods of Applied Geophysics. Gravity, magnetic, Poison’s
              relationship between gravity and magnetic potential, Gauss’s and
              Green’s theorems, Laplace’s equation, upward and downward
              continuation, Clariant’s theorem. Use of matrices in Applied
              Geophysics.{" "}
            </p>{" "}
            <h4>PHY 822.1 Electrical and Electromagnetic Method</h4>
            <p>
              Constitution of the atmosphere. Formation and structure of D-, E-,
              and F-layers of ionosphere. Vertical and Oblique propagation of
              radio waves in the ionosphere. Ionospheric absorption and fading,
              magneto-ionic theory. Ionospheric disturbances. Special features
              of the equatorial ionosphere.
            </p>{" "}
            <h4>PHY 823.1 Seismology Methods (Reflection and Refraction)</h4>
            <p>
              The theory of elastic waves, body and surface waves, curved wave
              front theory; principles of refraction prospecting; the inversion
              of body and surface waves data, resolution problems, modern
              techniques of refraction prospecting and applications. Recording
              methods in seismology; and introduction to earthquake seismology,
              seismically and seismic risk; earthquake prediction and risk
              reduction; African earthquakes. Principles of seismic reflection
              surveying; seismic sources and source array design, hydrophones
              and geophones, digital acquisition systems; vibroseis techniques;
              transmission of seismic energy, field techniques, digital
              processing of seismograms, migration and interpretation procedure.
              Introduction to seismic stratigraphy.
            </p>
            <h4>PHY 824.1 Borehole Geophysics and Radiometric</h4>
            <p>
              The theories and methods of boreholes geophysics will be
              introduced. Well logging techniques and interpretation principles
              in log interpretation will be treated. Principles of
              radioactivity, radioactivity of rocks and minerals, ionization
              chamber, Golfer Muller counter, scintillation meter, miscellaneous
              instrument and calibration. Field techniques. Spectrometric
              surveys. Aero-spectrometric methods. Interpretation
              techniques/procedures.
            </p>{" "}
            <h4>PHY 850.1 ICT and Research Methodology</h4>
            <p>
              This course should cover essential of spreadsheets, internet
              Technology, statistical packages, precision and Accuracy of
              Estimates, principles of scientific Research, concepts of
              Hypotheses formation and Testing, Organization of Research and
              Report Writing.
            </p>{" "}
            <h4>PHY 851.2 Management and Entrepreneurship</h4>
            <p>
              The course will cover business environment general management,
              financial management entrepreneurship developments, feasibility
              studies marketing and managerial problem solving.
            </p>{" "}
            <h4>
              PHY 825.2Time series Analysis, Digital filter theory and Data
              Processing
            </h4>
            <p>
              Signal theory. Continuous and discrete Fourier series. Convolution
              integral. Correlation integral. Filtering techniques-linear
              filter, convolution, auto-correlation, cross-correlation and power
              spectral analysis. De-convolution, matched filters and application
              of these filters to both synthetic and real data.
            </p>{" "}
            <h4>PHY 826.2 Research Seminars in Geophysics</h4>
            <p>
              Literature study, writing up and oral presentation of a topic on
              an aspect of the area of specialization.
            </p>{" "}
            <h4>PHY 827.2 Geophysical Field work</h4>
            <p>
              This course is designed to introduce the students to
              specialization in the techniques of data collection, analysis, and
              interpretation through geophysical filed work. Field Techniques in
              Applied Geophysics with emphasis on practical field work will be
              carried out. Improvements on existing and new techniques will also
              be introduced when they arise.
            </p>{" "}
            <h4>PHY 828.2 Gravity and magnetic methods in Geophysics</h4>
            <p>
              The earth’s field, measurement of gravity on land and at sea,
              reduction of gravity observations, rock density, regional and
              residual anomalies separation; gravity effect of simple shapes,
              interpretation of gravity effect of simple shapes, interpretation
              of gravity anomalies in terms of two- and three-dimensional
              structures; second derivative methods, limiting depths, field
              examples from Nigeria and elsewhere. The earth’s magnetic field;
              magnetometers and measurements of magnetic field on land and air,
              reduction of magnetic observation; magnetic properties of rocks,
              two- and three-dimensional interpretation of magnetic anomalies in
              terms of such models as the dyke model, field example from Nigeria
              and elsewhere. Magnetic reduction to pole, frequency domain
              analysis.
            </p>
            <h4>PHY 829.2 Research Project in Geophysics</h4>
            <p>
              Special geophysical investigation with the report including
              results and interpretation being presented in dissertation format.
            </p>
            <h4>PHY 850.1 ICT and Research Methodology</h4>
            <p>
              This course should cover essential of spreadsheets, internet
              Technology, statistical packages, precision and Accuracy of
              Estimates, principles of scientific Research, concepts of
              Hypotheses formation and Testing, Organization of Research and
              Report Writing.
            </p>
            <h3>ELECTIVE COURSES</h3>
            <h4>PHY 810.1 Numerical and Computational Methods</h4>
            <p>
              Interpretation Scheme, the lagrangian representation, Arkin
              algorithm least square. Interactive process. Solution of linear
              equations, Gaussian elimination, inversion of matrices. Fourier
              series and harmonic analysis. Difference equation. Numerical
              integration and differentiation trapezium, Simpson’s limitation of
              the size of grid. Solution of ordinary differential equation, step
              by step methods partial differential equation, simple ware
              propagation forward difference, backward difference, central
              difference in time, the implicit scheme, conditions for stability;
              e.g. diffusion equation, hyperbolic equation method of relaxation
              and other interactive schemes applied to simultaneous equations;
              ill-conditioned method. Functional representation, minimization
              and telescoping computer solutions of equations.
            </p>{" "}
            <h4>PHY 830.2 Instrumentation</h4>
            <p>
              The development and modification of Geophysical instruments will
              be treated.
            </p>{" "}
            <h4>PHY 831.1 Geophysical Prospecting</h4>
            <p>
              Gravity and magnetic methods, Electrical methods, seismic method,
              Electromagnetic method and Radiometrics shall be treated
            </p>{" "}
            <h4>PHY 832.2 Modelling in Geophysical Prospecting</h4>
            <p>
              Modelling conditions, modelling parameters. The resistivity model
              tank, magnetic response modelling. Electromagnetic scale
              modelling. Applications of modelling to geophysical
              interpretation.
            </p>{" "}
            <h4>PHY 833.2 Principles of Paleo-magnetism</h4>
            <p>
              Detrital magnetization, thermo-remnant magnetization, collection
              and treatment of Data, magnetic cleaning, measurement of natural
              remnant magnetization, investigation of other magnetic properties
              or rocks temperature effects, stereographic projection.
              Application of results of palaeomagnetism.
            </p>{" "}
            <h4>PHY 834.1 Geology for Non-Geologist</h4>
            <p>
              Introduction to the basic principles of stratigraphy applied
              physical stratigraphy. Introduction to structural Geology and
              Interpretation for potential mineral resources. Simple geological
              structures, interpretation of folds, faults and fractures. Basic
              map reading, photo-geology and interpretation, introduction to
              petrology: igneous, metamorphic and sedimentary. Mineral deposits,
              their geology and uses. Identification of various rock types and
              their composition, economic geology. Geology of petroleum, oil
              accumulation and nature, origin of oil, migration and accumulation
              of oil. Discussion of various traps, Basic concepts of
              Hydro/Engineering Geology and marine Geology.
            </p>{" "}
          </div>
          <div className={`panel ${checkActive(5, "active2")}`}>
            <center>
              {" "}
              <h3>COURSE DESCRIPTION FOR M.Sc. MATERIALS SCIENCE</h3>
            </center>
            <br />
            <h4>PHY 840.1 Mechanical Properties of Materials</h4>
            <p>
              Behaviour of Materials under stress, Mechanical properties in
              tension, compression, direct shear, tension, flexures, true
              stress-strain, cold work, hardness, impact, fatigue properties.
              Effect of temperature on mechanical behaviour of metals creep,
              stress and rapture. Toughness and crack production theories.
              Mechanical of slop, slip systems, critical resolved shear stress.
              Deformation in single polycrystalline materials. Impurity effects
              and yield point phenomena. Elements of dislocation theory. Effects
              of temperature and deformation of rate of plastic flow and strain
              hardening.
            </p>
            <h4>PHY 841.1 Special Engineering Materials</h4>
            <p>
              Microstructure, properties and uses of ceramics, polymers and
              metals as engineering materials. Dielectric and magnetic
              characteristics of materials. Manufacturing and processing of
              polymers. Mechanical behaviour of polymers and their thermal and
              electrical properties. Valmes engineering approach and
              organization for materials selection. Quality standard and quality
              control.
            </p>
            <h4>PHY 842.1 Thermodynamics of Materials</h4>
            <p>
              Law of thermodynamics. Free energy of heterogeneous reactions.
              Phase rule solutions. Classical and statistical; thermodynamics
              with emphasis on solid state phenomenology of metallic surface,
              phase equilibra in multicomponent systems, calculations of phase
              diagrams, thermodynamics of lattice defects and substructure.
              Simultaneous development of concepts of mass, energy and momentum.
              Introduction to irreversible thermodynamics and its application to
              solid diffusion.
            </p>
            <h4>
              PHY 843.1Electrometallurgy, corrosion and Materials Degradation
            </h4>
            <p>
              Electrode potential and over voltage. Electrode kinetics,
              corrosion types, corrosion mechanism, corrosion protection,
              electroplating, vacuum disposition, GalvanostraticCathode, Anodic
              and potentiostatic protection methods Effects of temperature,
              environmental and metallurgical factors on corrosion of materials.
              High temperature corrosion.
            </p>
            <h4>844.1 Powder Metallurgy and Processing</h4>
            <p>
              Introduction to properties of metal and ceramic powders. Basic
              principles of compacting porous and dense products. Microstructure
              factors affecting Physical and mechanical properties of powder
              blending; compacting, consolidation, sintering. Production of
              metal parts from powder and review of commercial applications.
              Important patents and commercial processes. Metallurgy of iron,
              steel and principal nonferrous materials. Gasses in steel,
              materials and energy balance. Slag-metal reaction
            </p>
            <p>
              Introduction to Physical metallurgy: Relation of properties to
              microstructure in materials recovery, recrystallization and grain
              growth. Introduction to atomic, microscopic structure of
              engineering materials. Effects of grain size and boundaries, work
              hardening and heat treatment on behaviour of solids. Phase
              diagrams. Solidification. Iron-carbon system. Ferrous and
              non-ferrous materials. Diffusion-controlled phase transformations,
              distortion-controlled phase transformation, Elementary alloy
              theory.
            </p>
            <h4>PHY 850.1: ICT and Research Methodology</h4>
            <p>
              This course should cover essential of spreadsheets, internet
              Technology, statistical packages, precision and Accuracy of
              Estimates, principles of scientific Research, concepts of
              Hypotheses formation and Testing, Organization of Research and
              Report Writing.
            </p>
            <h4>PHY 845.2 Thin Film Material Technology</h4>
            <p>
              Preparation, structure, evaluation and properties of thin films;
              metallic, semiconductor and dialectic film techniques. Nucleation
              and growth consideration, epitaxy and metastable configuration.
              Solar materials characteristics and their applications. Visible
              and infrared light sources, black body radiations, radiation by
              atoms, stimulated emission of radiation, coherent light sources
              and electro-optics effects/application.
            </p>
            <h4>PHY 846.2 Nanomaterials and Nanotechnology</h4>
            <p>
              Nanotechnology bottom-up approach versus to p-down approach in
              materials production, carbon nanomaterials, carbon nanotubes,
              nanorods, nanowiries, graphenes, semiconductor and nano metallic
              materials. Application of nanomaterials, Energy production,
              storage, transmission and use. Other applications of nanomaterials
              (Agriculture, medicine, drugs delivery, production, environmental
              remediation). Nano biotechnology and chemical technology.
            </p>
            <h4>PHY 847.2 Introduction to Ceramic Materials</h4>
            <p>
              Introduction to Ceramics-Minerals, Raw materials. Forming and
              thermal treatment obtain ceramic products. Glasses, glazes,
              ceramic and enamels on metals. Physical ceramics. Equilibrium and
              reactions between ceramic recrystallization, grain growth and
              microstructure of ceramics. Spatial characteristics of engineering
              ceramics plastic and viscous deformation in ceramics. Physical and
              dielectric properties.
            </p>{" "}
            <h4>PHY 848.2 Seminars in Advances in new Materials</h4>
            <p>
              Metallurgical materials, Bio-engineering materials, Computer
              applications in solving materials problems and advances in
              Materials Sciences. Students will be required to prepare and
              present seminars in chosen topics in which they have critically
              reviewed technical papers.
            </p>{" "}
            <h4>PHY 849.2 Project Research</h4>
            <p>
              Independent project research demonstrating professional maturity
              at graduate level and knowledge to undertaken and complete
              research under guidance of a department senior member who should
              normally be vast in the field will be undertaken. The report will
              include among other things critical and analytical analysis and
              interpretation of pertinent literature. This should in addition
              represent worthwhile contribution to the field. Oral and final
              examination of project report (thesis) is required for the award
              of the M.Sc. degree in Material Science.
            </p>{" "}
            <h4>PHY 851.2 Management and Entrepreneurship</h4>
            <p>
              The course will cover business environment general management,
              financial management entrepreneurship developments, feasibility
              studies marketing and managerial problem solving.
            </p>{" "}
          </div>
          <div className={`panel ${checkActive(6, "active2")}`}>
            {" "}
            <h3>
              COURSE DESCRIPTION FOR M.Sc. ENVIRONMENTAL PROTECTION AND
              RADIATION PHYSICS
            </h3>
            <br />
            <h4>PHY 850.1: ICT and Research Methodology</h4>
            <p>
              This course should cover essential of spreadsheets, internet
              Technology, statistical packages, precision and Accuracy of
              Estimates, principles of scientific Research, concepts of
              Hypotheses formation and Testing, Organization of Research and
              Report Writing.
            </p>{" "}
            <h4>PHY 861.1 Atmospheric Physics and Meteorology</h4>
            <p>
              The Solar-Earth atmospheric processes. The parameters for climate
              and meteorology. Element cloud physics, Hydrological cycle,
              precipitation, evaporation, atmospheric circulation, Energy
              budget, Ozone layer, Green House effects, Global warming.
              Structure of the Atmosphere and its constituents.
              Atmospheric-Environment Model, Land and see Breeze. Wind flow and
              its dynamics, Radiation, Temperature, Humidity, Atmospheric
              particulates emission and control and General circulation models.
              Nature of turbulent motion in various environment.
            </p>{" "}
            <h4>PHY 862.1 Fundamentals of Nuclear Physics</h4>
            <p>
              Introduction and basic concepts: Definitions, Nuclear properties,
              nuclear potential and energy levels. Radioactivity and
              transformation kinematics. Nuclear collisions. Nuclear
              instability: decay, electron capture (EC), decay and semi
              classical theory of decay, gamma decay and yield selection rules,
              internal conversion, (IC,) Auger, electron emission. Interaction
              of Radiation with matter: specific ionization, linear energy
              transfer (LET): Mechanisms and energy transfer of Heavy changed
              particles (Bethe-Bloch formula, Bragg curve, energy requirements
              etc), fast elements, gamma-rays, neutrons including attenuation
              and moderation. Nuclear reactions: general features of nuclear
              reactions, elastic scattering, direct reaction, compound nucleus
              reaction. Heavy ion’s reaction. Brief view of concepts and
              principles of reactors and criticality.
            </p>{" "}
            <h4>
              PHY 863.1 Radiation Detection, Dosimetry and Radiation Protection
            </h4>
            <p>
              Radiation quantities: Definitions and Units Radiation detection
              methods: ionization in gases; Ionization in semiconductors.
              Scintillation Gamman spectrometry. Neutron detection. Thermo
              luminescence. Film Dosimetry, Chemical dosimeter (Fricke).
              Particle Track detection, calorimetry, etc. counting statistics
              dosimetry: External dosimetry (gamma). Internal dosimetry.
              Reference Man Patient Dosimetry in radiographic external dosimetry
              (gamma). Internal dosimetry, Reference man patient Dosimetry in
              radiographic examination, mammography, fluoroscopy and computed
              tomography.
            </p>{" "}
            <p>
              The external Radiation Hazard and Protection. Time distance and
              shielding, monitoring for external radiations (areas and
              personal). The internal Radiation Hazard and Protection: Sources
              and type of airborne contaminants, control of the internal
              radiation hazard, exposure reduction, internal dosimetry. Waste
              Management of Contamination, protection against contamination
              (protective clothing, decontamination of waste disposal, packaging
              and safe transport of radioactive materials. Principles to
              Radiation protection Justification, optimization, dose limit,
              international safety standards ICRP, BSs, NNRA, Elements of
              Radiation protection programmed in Medicine and dosimetry:
              Monitoring, Emergency preparedness planning and response. QA and
              QC instrument. Training, Audit, Safety of equipment.
            </p>
            <h4>PHY 864.1 Environmental Sciences and Modelling</h4>
            <p>
              The concept of Environmental Science. The inter disciplinary
              nature of environmental science. Biodiversity, Man’s activities,
              ecosystems and limitations, sources of Environmental Pollution.
              Environmental impacts on Air, Land and Water. Environmental
              control and management. The physics, chemistry, biochemistry,
              bacteria, etc, concepts of pollution. Environmental standard and
              sustainable development. Radioactive and toxic pollutants. Gaseous
              pollutants; carbon dioxide, carbon monoxide, sulphur dioxide,
              nitrogen oxides, photo chemical pollutants, acid rain, homogenate
              compounds. Sound and noise pollution. Sound propagation
              measurement and Analysis. Physics of Noise and Sound. Effect of
              sound. Basic sources of Noise: Character and treatment. Noise
              scales and indices. Noise control methods. Environmental
              acoustics. Sound reduction. Practical and reduction methods.
              Criteria and recommendation and Noise legislation.{" "}
            </p>
            <p>
              Introduction of general concepts of mathematical modelling.
              Continuous and discrete techniques in mathematical modelling.
              Application of modelling techniques in solving measured
              environmental data. Testing of Hypothesis, decision theory and
              multivariate analysis. Numerical methods of linear equations and
              approximations. Sampling methods and Quality control
              measures/precision. The finite difference schemes. Applications in
              fluid dynamics and Diffusion mechanism
            </p>
            <h4>PHY 851.2 Management and Entrepreneurship</h4>
            <p>
              This course will cover business environment, general management,
              financial management, entrepreneurship development, feasibility,
              studies, marketing and managerial problems solving.
            </p>{" "}
            <h4>PHY 865.2 Physics of Fluids and Water Resources Management</h4>
            <p>
              General principles of Fluid Dynamics. Transport mechanism (Air,
              Water and Soil) capillarity, permeability. Absorption and
              Adsorption processes and fluid Tension. Flow network and seepage
              phenomenon. Surface water runoff process, linear and non-linear
              hydrological model, Stream flow routing, and boundary layer flow.
              Ground water pollution. Modelling natural waters and treatment of
              systems. Introduction to principles of surface and groundwater
              hydrology. Sources of water. Water as a renewable resource.
              Aquifer analysis. Groundwater quality, its chemistry, migration
              and relation to geologic environment. Steady and unsteady flow of
              water. Groundwater pollution. Hydraulic conductivity,
              transmission, yield and storage. Quality analysis of water. Water
              profile, properties and characteristics of water. Hydrologic
              cycle. Meteorological consideration. Analysis of precipitation,
              runoff, flood routing and reservoir storage. Water resources
              investigation. Waste water treatment comparison of alternatives,
              screening and formulation of management projects. System models of
              water transportation to rivers and streams.
            </p>
            <h4>
              PHY 866.2 Nuclear Application in Medicine, Industry and Research{" "}
            </h4>
            <p>
              Physics and Principles of diagnostic imaging equipment:
              radiographic unit, computed tomography, mammographic units.
              Principles of radiation therapy (teletherapy and brachytherapy).
              Physics of radiotherapy equipment; CO-60 unit and Linear
              accelerator. Physics and operational principles of Gamma camera.
              Physics of position (‘?’) emission Tomography PET). Physics and
              operational principles of Magnetic Resonance Imaging (MRI).
              Industrial Uses: Industrial radiography, tracing, Gauging,
              Material Modification, Sterilization food preservation and others.
              Research Uses. Neutron Activation Analysis. Particle-induced N-ray
              Emission PIXE and others.
            </p>
            <h4>
              PHY 868.2Seminar in Environmental Innovations and Nuclear Issues
            </h4>
            <p>
              Students will be required to prepared and present seminars in
              chosen topics in which they have critically reviewed. The
              technical papers should cover current issue and innovations on the
              environment and nuclear applications.
            </p>
            <h4>PHY 869.2 Project work</h4>
            <p>
              Post-graduate project will be tailored towards proffering solution
              to environmental problems in a chosen area. An analytical design
              or empirical study in applied physics with a blend in
              environmental concepts will be highly encouraged. The choice of
              project topic shall be in consultation with the Head of Department
              and an academic adviser. Written thesis shall be presented to the
              Department in consultation with the supervisor.
            </p>
            <h3>Electives</h3>
            <h4>PHY 852.1 Non-Ionizing Radiation</h4>
            <p>
              Ultraviolet radiation, micro wave radiation, electromagnetic
              radiation x-rays, Bleared Gamma radiation. Radiometric Units
              Lasers. Laser operations. Lasing actions, TEM modes, biological
              effects: eye damage, skin damage Protection guides and standards,
              maximum permissible Exposure (MPE). Safety Measurements, power and
              energy. Beam divergence Radiofrequency (RF) and Microwave:
            </p>
            <p>
              Communications, antennas and antenna gain. G. penetration depth
              GSM land-sets and base stations. Biological Effects. Thermal and
              Non- Thermal Effects, temperature-humidity index microwave
              measurement, survey meters. Protection Guides and standard Maximum
              permissible exposure (MPE) Safety.
            </p>
            <h4>PHY 853.2 Soil Mechanism and Properties</h4>
            <p>
              General theory of soil composition and classification.
              Characteristic of soil properties and Dynamics. Stress
              distribution in homogenous and layered elastic soil. Soil
              consolidation theory. Settlement of structure on soils. Bearing
              capacity and lateral earth pressure on soil. Stability and
              landslide phenomena. Soil and ground water pollution. Physical
              concepts of soil-soil improvement, particle size analysis,
              laterites, site investigation. Critical evaluation and review of
              standard testing procedures for soil identification. Treatment of
              shear strength static triaxial compression test and its several
              variations.
            </p>{" "}
            <h4>PHY 867.2 Introduction to Environmental Technology</h4>
            <p>
              Environmental technology and Environmental Science. Measurement
              and Evaluation of environmental pollution in air, water and land:
              legal and technical requirements in the preparation,
              interpretation of environmental impacts. The procedure and
              interdisciplinary nature of environmental analysis.
            </p>{" "}
            <ul>
              <li>Impact Evaluation</li>
              <li>Qualification of Impacts</li>
              <li>Fields</li>
              <li>Mitigation</li>
              <li>
                Understanding the sources and projects that cause Environmental
                degradation
              </li>
              <li>Remediation of gaseous pollutants.</li>
            </ul>
            <p>
              Removal of gaseous oxides of nitrogen, Carbon and sulphur. Removal
              of particulates from moving and stationary sources. Removal of
              fluorides complex oxidants and mercury vapour. The principles of
              reactions and physical measurements applied for variety of
              analytical equipment employed in air quality studies.
            </p>
            <p>
              Practical examples and case studies will be used. These may
              include evaluation and analysis of
            </p>
            <ul>
              <li>Social and industrial Noise</li>
              <li>Vibration hazards, toxic and radioactive materials</li>
            </ul>
            <p>
              Statistical analysis and modelling of environmental systems.
              In-situ and online measurement of environmental pollution. Types
              of environmental studies, EIA. EAR. Environmental Monitoring
            </p>
            <h4>Ph.D. PROGRAMME</h4>
            <p>
              The PhD programme is geared towards (a) the production of high
              calibre specialists in the various options for services in higher
              institutions and the industry (b) the introduction of high level
              of research experiences and (c) the development of originality,
              interdisciplinary and cooperative research, analytical and a
              critical mind.
            </p>{" "}
            <h4>1 REGULATIONS</h4>
            <p>
              The programmes for degree of Doctor of philosophy (PhD) shall
              consist of a minimum of 48 credit units out of which 30 credit
              units is expected from master’s work. The other 18 credit units
              shall come from approved courses of study, Seminars and Research
              project.
            </p>{" "}
            <h4>2 DURATION OF PROGRAMME</h4>
            <p>
              The PhD candidates will be required to spend a minimum of 24
              calendar months (2 years) and a maximum of 60 calendar months
              (5years) for Full-Time.
            </p>
            <p>
              Part-Time candidates will be required to spend a minimum of 36
              calendar months (3years) and a maximum of 84 calendar months
              (7years).
            </p>
            <h4>3 COURSE ASSESSMENT</h4>
            <p>
              The PhD programme is in accordance with the existing regulations
              of the University of Port Harcourt. To be qualified for the award
              of the PhD. degree in any of the options, the following
              requirements must be met:
            </p>
            <ul>
              <li>
                The candidate will be required to deliver four seminars in
                his/her area of specialization before graduation (3 Seminars in
                Department, 1 at Faculty, 1 at graduate School)
              </li>
              <li>
                The candidate shall attend at least two professional
                conferences.
              </li>
              <li>
                A thesis must be submitted after completion and defended orally
                before an officially appointed External Examiner in accordance
                with University of Port Harcourt regulations.
              </li>
            </ul>
          </div>
          <div className={`panel ${checkActive(7, "active2")}`}>3</div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />

        <p></p>
        <h4></h4>
        <p></p>
        <h4></h4>
        <p></p>
      </div>
      <div className="col-md-12 lecturers-section mtt">
        <center>
          <h1>Our Leadership</h1>
          <p>There are many variations of passages of Lorem Ipsum</p>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image4} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        {/* <Carousel
          show={isMobile ? 1 : 3}
          slide={1}
          autoSwipe={0}
          transition={0.9}
          swiping={true}
          infinite={true}
          useArrowKeys={true}
        > */}{" "}
        <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8">
          {state.list.map((data, index) => (
            <Lecturers data={data} />
          ))}
        </div>
        {/* </Carousel> */}
      </div>
    </>
  );
};
